import { httpsCallable, type HttpsCallableResult } from "firebase/functions";
import { functions } from "../firebase";
import type { BookingRequest, BookingResult } from "../lib/types";

// The booking is created by a callable Cloud Function, never written directly by
// the client. The function re-validates availability and enforces the per-breed
// daily cap inside a transaction (the authoritative path), then queues the
// invite email. Returned errors carry a friendly message in err.message.
const callable = httpsCallable<BookingRequest, BookingResult>(functions, "bookAppointment");

export async function bookAppointment(req: BookingRequest): Promise<BookingResult> {
  const res: HttpsCallableResult<BookingResult> = await callable(req);
  return res.data;
}
